import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getSellerPOs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOs - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOBySellerPOId = async (sellerPOId, fetchEntireDocDetails) => {
    try {
        const fetchEntireDocDetailsFlag = fetchEntireDocDetails ? true : ""
        const response = await axios.get(`${REACT_APP_API_URL}/seller-po/${sellerPOId}?fetchEntireDocDetails=${fetchEntireDocDetailsFlag}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOBySellerPOId - error", error)
        return handleApiError(error)
    }
}

export const insertPIPunch = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/create-pi-punch/`, data);
        return await response.data;
    } catch (error) {
        console.log("insertPIPunch - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOsByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/buyer-req`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOsByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const updateSellerPO = async (sellerPOId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/update/${sellerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateSellerPO - error", error)
        return handleApiError(error)
    }
}

export const getSellerPO = async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-po/dispatch/total-seller-po`);
        return await response.data;
    } catch (error) {
        console.log("getSellerPO - error", error)
        return handleApiError(error)
    }
}

export const cancelSellerPO = async (sellerPOId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/cancel-seller-po/${sellerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelSellerPO - error", error)
        return handleApiError(error)
    }
}

export const reviseSellerPO = async (sellerPOId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/revise/${sellerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("reviseSellerPO - error", error)
        return handleApiError(error)
    }
}

export const insertSellerPO = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/insert-sellerpo`, data);
        return await response.data;
    } catch (error) {
        console.log("inserSellerPO - error", error)
        return handleApiError(error)
    }
}

export const getMaterialIDTeamNames = async () => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/materialid-team`);
        return await response.data;
    } catch (error) {
        console.log("getMaterialIDTeamNames - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOByDocNum = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/seller-po/get-seller-po-by-doc-num/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOByDocNum - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOsRaw = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/search`, data);
        return await response.data;
    } catch (error) {
        console.log("getSellerPOsRaw - error", error)
        return handleApiError(error)
    }
}

export const getSellerPOByBuyerPOIds = async (data) => {
    try {
        const response =  await axios.post(`${REACT_APP_API_URL}/seller-po/buyer-po`, data)
        return await response.data;
    } catch (error) {
        console.log("getSellerPOByBuyerPOIds - error", error)
        return handleApiError(error)
    }
}

export const getPastSellerPOMaterialTransactions = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/past-sel-po-material-transactions`, data);
        return await response.data;
    } catch (error) {
        console.log("getPastSellerPOMaterialTransactions - error", error)
        return handleApiError(error)
    }
}

export const sendSellerPOMail = async (sellerPOId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/send-seller-po-mail/${sellerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("sendSellerPOMail - error", error)
        return handleApiError(error)
    }
}

export const getPastSellerPOsByCompanyIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/past-sel-pos`, data)
        return await response.data
    } catch (error) {
        console.log("getPastSellerPOsByCompanyIds - error", error)
        return handleApiError(error)
    }
}


export const getNonRoutedSellerPOsInfoBySellerPOs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/seller-po/non-routed-sel-pos`, data)
        return await response.data
    } catch (error) {
        console.log("getNonRoutedSellerPOsInfoBySellerPOs - error", error)
        return handleApiError(error)
    }
}